// @mui material components
import Card from "@mui/material/Card";
import React, { useEffect, useMemo, useState } from "react";

// Soft UI Dashboard React components
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EmailIcon from "@mui/icons-material/Email";
import LinkIcon from "@mui/icons-material/Link";
import PhoneIcon from "@mui/icons-material/Phone";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
// Soft UI Dashboard React examples
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import headerBg from "assets/images/curved-images/Header.png";
import checkboxgreen from "assets/images/logos/checkboxgreen.png";
import checkboxwhite from "assets/images/logos/checkboxwhite.png";
import { ReactComponent as EmptyFolderIcon } from "assets/images/small-logos/icon-emptyFolder.svg";
import SoftAvatar from "components/SoftAvatar";
import DeleteInspection from "components/SoftDialog/DeleteInspection";
import CircularLoader from "components/SoftDialog/Loader";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CustomTable from "examples/Tables/Table";
import html2pdf from "html2pdf.js";
import { useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import truncateString from "services/truncatestring";
import DeficiencyRow, { Deficiencycolumns } from "store/action/Deficiency";
import api from "store/api/api";
import useStore from "store/hook";
import getDateOrTime from "../../services/getDateOrTime";
import formatStringWithSpaces from "../../services/stringconverter";
import getTimeFromMilliseconds from "../../services/timeconverter";
import { InspectionSection } from "./components/InspectionSection";

import {
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

import brand from "assets/images/logos/image.png";
import AddDeficiency from "components/SoftDialog/AddDeficiency";
import ChangeStatusBackOfInspection from "components/SoftDialog/ChangeStatusBackOfInspection";
import ChangeStatusOfInspection from "components/SoftDialog/ChangeStatusOfInspection";
import ChangeStatusOfInspectionAdmin from "components/SoftDialog/ChangeStatusOfInspectionAdmin";
import DeleteDeficiencylog from "components/SoftDialog/DeleteDeficiencylog";
import SoftPagination from "components/SoftPagination";
import { FaPlus } from "react-icons/fa";
import { MdOutlineDownload } from "react-icons/md";
import { toast } from "react-toastify";
import convertMillisecondsToDate from "services/dateconverter";
import formatPhoneNumber from "services/formatPhoneNo";
import getDateFromSeconds from "services/getDate";
import getFormattedDate from "services/simpleDateformat";
import { UPLOAD_IMAGES } from "store/api/apiConstants";
import { DELETE_IMAGES } from "store/api/apiConstants";

const weatherData = [
  { label: "Weather Condition" },
  { label: "Temperature" },
  { label: "Deficiencies Found" },
  { label: "Status" },
];

const InspectionData = [
  { label: "Inspection Number" },
  { label: "Temperature" },
  { label: "Deficiencies Found" },
];

function InspectionOverview() {
  const { setDialogue, store } = useStore();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [inspectionData, setInspectionData] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [links, setLinks] = useState([]);
  const [manager, setManager] = useState([]);
  const [contacts, setContact] = useState([]);
  const [discipline, setDiscipline] = useState([]);
  const [referenceData, setReferenceData] = useState({});
  const [pdfloading, setPdfLoading] = useState(false);
  const [pfdData, setPdfData] = useState([]);
  const [pdfdata2, setpdfdata2] = useState([]);
  const [imagesDiscipline, setImagesDiscipline] = useState([]);
  const [managerSignature, setManagerSignature] = useState("");
  const [inspectorSignature, setInspectorSignature] = useState("");
  const [deleted, setDeleted] = useState(false);
  const [currentUserRole, setCurrentUserRole] = useState("");
  const { success } = store?.app?.dialogs?.isSuccess || {};
  const [pdfUrl, setPdfUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [showInspections, setShowInspections] = useState(true);
  const [page, setPage] = useState(1);
  const [deficiecncylogData, setDeficiencylogData] = useState(null);
  const [downloadDeficiencylogData, setDownloadDeficiencylogData] =
    useState(null);
  const [pagination, setPagination] = useState(null);
  const [logpdfLoading, setlogpdfLoading] = useState(false);
  const [PifNumber, setPifNumber] = useState({
    type: "",
    value: "",
  });
  const [reviewedBy, setReviewBy] = useState(null);
  const [inspectedBy, setInspectedBy] = useState(null);
  const [deficiencylogLoading, setDeficiencylogLoading] = useState(false);
  const [inspectorData, setInspectorData] = useState({
    name: "",
    image: "",
    id: "",
  });
  let labelCharCode = 65;

  const BASE_URL = process.env.REACT_APP_PROD_URL;

  let lastFailedRequest = false;

  const deficiencyRows = useMemo(
    () =>
      deficiecncylogData?.length
        ? deficiecncylogData.map((deficiency) =>
            DeficiencyRow(deficiency, setDialogue, projectData?._id),
          )
        : [],
    [deficiecncylogData, setDialogue],
  );

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("loginData"));
    if (!loginData) {
      navigate("/authentication/signin");
    } else {
      setCurrentUserRole(loginData.account_type);
      fetchInspectionDetails();
      fetchAllDeficiencyList();
    }
  }, [navigate, success]);

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("loginData"));
    if (!loginData) {
      navigate("/authentication/signin");
    } else {
      setCurrentUserRole(loginData.account_type);
      fetchDeficiencyList();
    }
  }, [navigate, success, page]);

  const fetchInspectionDetails = async () => {
    try {
      setIsLoading(true);

      const response = await api.getInspectionDetails({
        inspection_id: id,
        is_deleted_needed: true,
      });

      setInspectionData(response.data);
      setInspectorData(
        response?.data?.updated_inspector?._id
          ? {
              name: response?.data?.updated_inspector?.full_name,
              image: response?.data?.updated_inspector?.profile_picture,
              id: response?.data?.updated_inspector?._id,
            }
          : {
              name: response?.data?.added_by?.full_name,
              image: response?.data?.added_by?.profile_picture,
              id: response?.data?.added_by?._id,
            },
      );

      setInspectorSignature(
        response?.data?.updated_inspector?._id
          ? response?.data?.updated_inspector?.signature
          : response.data.added_by?.signature,
      );

      setProjectData(response?.data?.projectDetail);
      setLinks(response?.data?.projectDetail?.links);
      setManager(response?.data?.projectDetail?.manager);
      if (response?.data?.projectDetail?.manager) {
        setManagerSignature(
          response?.data?.reviewed_by?._id
            ? response?.data?.reviewed_by?.signature
            : response?.data?.projectDetail?.manager[0].signature,
        );
      }
      setContact(response?.data?.projectDetail?.site_contacts);
      setDiscipline(response?.data?.discipline_data);
      if (response?.data?.discipline_data?.length > 0) {
        setImagesDiscipline(
          response?.data?.discipline_data.flatMap((item) => {
            const currentLabel = String.fromCharCode(labelCharCode++);

            return (item.images || []).map((image, index) => ({
              image: image,
              inspectionType: item?.inspectionType,
              label: `${currentLabel}-${index + 1}`,
            }));
          }),
        );
      }

      setReferenceData(response?.data?.refferenceData);
      setPifNumber({
        type: response?.data?.pif_type,
        value: response?.data?.pif_value,
      });

      setReviewBy(response?.data?.reviewed_by);
      setInspectedBy(response?.data?.updated_inspector);

      setPdfData([
        {
          name: "Project Name",
          email: response?.data?.projectDetail?.name || "",
          phone: "Project Inspection Form",
          value: ` ${response?.data?.inspection_number}-${response?.data?.inspection_discipline_start}`,
        },
        {
          name: "Location",
          email: response?.data?.projectDetail?.location || "",
          phone: "Project No.",
          value: `#${response?.data?.projectDetail?.project_number}` || "",
        },
      ]);

      setpdfdata2([
        {
          name: "Weather",
          email: response?.data?.weather_condition,
          phone: "Temperature",
          temp: response?.data?.temperature,
        },
        {
          name: "Date",
          email: getDateOrTime(
            convertMillisecondsToDate(response?.data?.inspectionTime, "long"),
            "date",
          ),
          phone: "Time",
          value: getDateOrTime(
            convertMillisecondsToDate(response?.data?.arrival_time),
            "time",
          ),
        },
      ]);

      if (response?.status == 0) {
        toast.error(response?.message);
        setDeleted(true);
      }

      if (response?.status == 7) {
        setDeleted(true);
      }
    } catch (error) {
      toast.error("Internal Server Error");
      lastFailedRequest = true;
      toast.error("Oops! Slow network or server issue. Please try again.");
      console.error("Error in fetching details", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDeficiencyList = async () => {
    try {
      setDeficiencylogLoading(true);
      const response = await api.getDeficiecnylogList({
        insepctionId: id,
        page: page,
        limit: 50,
      });

      setDeficiencylogData(response?.data?.deficiecncylog);
      setPagination(response?.data?.pagination);
    } catch (error) {
      lastFailedRequest = true;
      console.error("Error fetching Deficiency log:", error);
    } finally {
      setDeficiencylogLoading(false);
    }
  };

  const fetchAllDeficiencyList = async () => {
    try {
      setIsLoading(true);
      const response = await api.getAllDeficiecnylogList({
        id: id,
        type: "inspection",
      });
      if (response?.status == 1) {
        setDownloadDeficiencylogData(response?.data);
      }
    } catch (error) {
      console.error("Error fetching Deficiency log:", error);
    } finally {
      setIsLoading(false);
    }
  };

  window.addEventListener("online", () => {
    if (lastFailedRequest) {
      fetchInspectionDetails();
      fetchDeficiencyList();
      lastFailedRequest = false;
    }
  });

  const ImageComponent = ({ imageUrl }) => {
    const [imageSrc, setImageSrc] = useState(imageUrl);

    useEffect(() => {
      // const convertImage = async () => {
      //   if (imageUrl?.startsWith("https://firebasestorage.googleapis.com")) {
      //     const base64Image = await convertImgToBase64(imageUrl);
      //     setImageSrc(base64Image);
      //   }
      // };
      // convertImage();
      setImageSrc(imageUrl);
    }, [imageUrl]);

    return (
      <SoftBox component="img" src={imageSrc} alt="Soft UI Logo" width="100%" />
    );
  };

  const convertImgToBase64 = async (imgUrl) => {
    try {
      const response = await fetch(imgUrl, { mode: "cors" }); // Ensure CORS is enabled
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting image to Base64:", error);
      return imgUrl; // Fallback to original URL if Base64 conversion fails
    }
  };

  const replaceImagesWithBase64 = async () => {
    const images = document.querySelectorAll("img");
    for (let img of images) {
      if (img.src.startsWith("https://firebasestorage.googleapis.com")) {
        img.src = await convertImgToBase64(img.src);
      }
    }
  };

  const uploadImagesToServer = async (firebaseImageUrls) => {
    try {
      // console.log(firebaseImageUrls);
      const response = await fetch(`${BASE_URL}${UPLOAD_IMAGES}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("loginData")
            ? JSON.parse(localStorage.getItem("loginData")).token
            : "",
        },
        body: JSON.stringify({ imageUrls: firebaseImageUrls }), // Send the array directly
      });

      // Check for server-side errors
      if (!response.ok) {
        throw new Error(
          `Server error: ${response.status} ${response.statusText}`,
        );
      }

      const data = await response.json();
      return data.newImageUrls;
    } catch (error) {
      console.error("Error uploading images:", error);
      return firebaseImageUrls; // Fallback to original URLs if upload fails
    }
  };

  const deleteImagesFromServer = async (deleteImageUrls) => {
    try {
      const response = await fetch(`${BASE_URL}${DELETE_IMAGES}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("loginData")
            ? JSON.parse(localStorage.getItem("loginData")).token
            : "",
        },

        body: JSON.stringify({ imagePaths: deleteImageUrls }), // Send the array directly
      });

      // Check for server-side errors
      if (!response.ok) {
        throw new Error(
          `Server error: ${response.status} ${response.statusText}`,
        );
      }

      const data = await response.json();
      return data.status;
    } catch (error) {
      console.error("Error uploading images:", error);
      return deleteImageUrls; // Fallback to original URLs if upload fails
    }
  };

  const updateDOMWithNewImages = (newImageUrls) => {
    if (!contentRef.current) return;

    // Select only images inside elements with class 'pdf-image'
    const images = contentRef.current.querySelectorAll(".pdf-image");

    images.forEach((img, index) => {
      if (newImageUrls[index]) {
        img.src = newImageUrls[index]; // Update the src attribute
      }
    });
  };

  const updateDOMWithManagerSignature = (newImageUrls) => {
    if (!contentRef.current) return;

    // Select only images inside elements with class 'pdf-image'
    const images = contentRef.current.querySelectorAll(".manager-signature");

    images.forEach((img, index) => {
      if (newImageUrls[index]) {
        img.src = newImageUrls[index]; // Update the src attribute
      }
    });
  };

  const updateDOMWithInspectorSignature = (newImageUrls) => {
    if (!contentRef.current) return;

    // Select only images inside elements with class 'pdf-image'
    const images = contentRef.current.querySelectorAll(".inspector-signature");

    images.forEach((img, index) => {
      if (newImageUrls[index]) {
        img.src = newImageUrls[index]; // Update the src attribute
      }
    });
  };

  const contentRef = useRef(null);
  const deficiencypdfRef = useRef(null);

  const generatePDF = async () => {
    if (!contentRef.current) return;
    let deletedImagesArray = [];
    setPdfLoading(true);
    let uploadedManagerSignature = "";
    let uploadedInspectorSignature = "";
    if (imagesDiscipline.length > 0) {
      const newImageUrls = await uploadImagesToServer(
        imagesDiscipline?.map((item) => item.image),
      );
      if (newImageUrls.length > 0) {
        updateDOMWithNewImages(newImageUrls);
        deletedImagesArray = [...deletedImagesArray, ...newImageUrls];
      }
    }

    if (managerSignature != "") {
      const uploadManagerSignature = await uploadImagesToServer([
        managerSignature,
      ]);
      if (uploadManagerSignature.length > 0) {
        updateDOMWithManagerSignature(uploadManagerSignature);
        uploadedManagerSignature = uploadManagerSignature[0];
        deletedImagesArray = [...deletedImagesArray, ...uploadManagerSignature];
      }
    }
    if (inspectorSignature != "") {
      const uploadInspectorSignature = await uploadImagesToServer([
        inspectorSignature,
      ]);
      if (uploadInspectorSignature.length > 0) {
        updateDOMWithInspectorSignature(uploadInspectorSignature);
        uploadedInspectorSignature = uploadInspectorSignature[0];
        deletedImagesArray = [
          ...deletedImagesArray,
          ...uploadInspectorSignature,
        ];
      }
    }

    await new Promise((resolve) => setTimeout(resolve, 1000));

    const element = contentRef.current;

    const options = {
      margin: [5, 5, 20, 5],
      filename: `${projectData?.name}  ${inspectionData?.inspection_number}-${inspectionData?.inspection_discipline_start}.pdf`,
      image: { type: "jpeg", quality: 0.7 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["css", "legacy"] },
    };

    await new Promise((resolve) => setTimeout(resolve, 1000));

    const pdf = await html2pdf().from(element).set(options).toPdf().get("pdf");

    const totalPages = pdf.internal.getNumberOfPages();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    pdf.setPage(1);
    pdf.setFontSize(9); // Reduce font size slightly

    // Positioning
    const leftX = pageWidth / 4;
    const rightX = (3 * pageWidth) / 4;
    const topY = pageHeight - 45; // Move everything up
    const lineOffset = 3; // Adjust line height
    const textOffset = 6; // Adjust text positioning
    const signatureHeight = 14; // Reduce signature image height
    const signatureWidth = 40; // Reduce signature image width

    function getJsPdfImageFormat(url) {
      const extMatch = url.match(/\.(\w+)(?=\?|$)/);
      if (!extMatch) return null;

      const ext = extMatch[1].toLowerCase();
      if (ext === "jpg" || ext === "jpeg") return "JPEG";
      if (ext === "png") return "PNG";
      if (ext === "webp") return "WEBP"; // If using plugin
      return null; // unsupported format
    }

    let managerSignatureFormat = "PNG";
    let inspectorSignatureFormat = "PNG";

    if (uploadedManagerSignature != "") {
      managerSignatureFormat = getJsPdfImageFormat(uploadedManagerSignature);
    }
    if (uploadedInspectorSignature != "") {
      inspectorSignatureFormat = getJsPdfImageFormat(
        uploadedInspectorSignature,
      );
    }

    // const managerSignatureFormat = getImageFormat(uploadedManagerSignature);
    // const inspectorSignatureFormat = getImageFormat(uploadedInspectorSignature);

    // ========== LEFT SIDE (Reviewed By) ==========
    // pdf.text(manager?.[0]?.full_name || "", leftX, topY, { align: "center" });
    // pdf.line(20, topY + lineOffset, pageWidth / 2 - 10, topY + lineOffset);
    // pdf.text("Reviewed By - Printed Name", leftX, topY + textOffset, {
    //   align: "center",
    // });

    // Signature (Reviewed By)
    // if (managerSignature != "") {
    //   pdf.addImage(
    //     uploadedManagerSignature,
    //     managerSignatureFormat,
    //     leftX - 20,
    //     topY + textOffset + 2,
    //     signatureWidth,
    //     signatureHeight
    //   );
    // }
    // pdf.line(20, topY + 20, pageWidth / 2 - 10, topY + 20);
    // pdf.text("Reviewed By - Signature", leftX, topY + 25, { align: "center" });

    // ========== RIGHT SIDE (Inspected By) ==========
    // pdf.text(inspectionData?.added_by?.full_name  || "", rightX, topY, {
    //   align: "center",
    // });
    // pdf.line(
    //   pageWidth / 2 + 10,
    //   topY + lineOffset,
    //   pageWidth - 20,
    //   topY + lineOffset
    // );
    // pdf.text("Inspected By - Printed Name", rightX, topY + textOffset, {
    //   align: "center",
    // });

    // // Signature (Inspected By)
    // if (inspectorSignature != "") {
    //   pdf.addImage(
    //     uploadedInspectorSignature,
    //     inspectorSignatureFormat,
    //     rightX - 20,
    //     topY + textOffset + 2,
    //     signatureWidth,
    //     signatureHeight
    //   );
    // }
    // pdf.line(pageWidth / 2 + 10, topY + 20, pageWidth - 20, topY + 20);
    // pdf.text("Inspected By - Signature", rightX, topY + 25, {
    //   align: "center",
    // });

    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(9);

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const footerText = [
        "4795 S. Church St. Ext. Suite 2",
        "Roebuck, SC 29376",
        "(864) - 586-6111",
      ];

      footerText.forEach((line, index) => {
        pdf.text(line, pageWidth / 2, pageHeight - 15 + index * 5, {
          align: "center",
        });
      });

      pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 20, pageHeight - 10, {
        align: "right",
      });
    }

    if (
      inspectionData?.status == "ready_for_distribution" ||
      inspectionData?.status == "archived"
    ) {
      pdf.save(options.filename);
    } else {
      const pdfBlob = pdf.output("blob");
      const blobUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(blobUrl);
      setOpen(true);
    }

    await deleteImagesFromServer(deletedImagesArray);
    setPdfLoading(false);
  };

  const generateDeficiencyPDF = async () => {
    if (!deficiencypdfRef.current) return;

    setlogpdfLoading(true);
    const element = deficiencypdfRef.current;

    const options = {
      margin: [70, 5, 10, 5],
      filename: `${projectData?.name}_DeficiencyLog.pdf`,
      image: { type: "jpeg", quality: 0.7 },
      html2canvas: { scale: window.devicePixelRatio * 3 || 3, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
      pagebreak: {
        mode: ["avoid-all", "css", "legacy"],
        before: ".force-page-break", // 👈 Add this
      },
    };

    const pdf = await html2pdf().from(element).set(options).toPdf().get("pdf");

    const totalPages = pdf.internal.getNumberOfPages();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const leftX = pageWidth / 4;
    const rightX = (3 * pageWidth) / 4;
    const topY = pageHeight - 215; // Move everything up
    const lineOffset = 3; // Adjust line height
    const textOffset = 6; // Adjust text positioning
    const signatureHeight = 20; // Reduce signature image height
    const signatureWidth = 40; // Reduce signature image width

    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);

      // pagno
      pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 130, pageHeight - 10, {
        align: "right",
      });

      // left side footer
      const footerText1 = [
        "For complete deficiency details",
        "see report listed under deficiency PIF # column",
      ];

      footerText1.forEach((line, index) => {
        pdf.text(line, pageWidth / 6 - 38, pageHeight - 15 + index * 5, {
          align: "left",
        });
      });

      pdf.addImage(
        brand,
        rightX - 90,
        topY + textOffset + 2,
        signatureWidth,
        signatureHeight,
      );

      pdf.text(
        "Helping Ensure a Safer Built Environment",
        rightX - 70,
        topY + textOffset + 25,
        {
          align: "center",
        },
      );

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(12);

      pdf.text("Deficiency Log", rightX - 70, topY + textOffset + 35, {
        align: "center",
      });

      pdf.text(projectData?.name, rightX - 70, topY + textOffset + 48, {
        align: "center",
      });

      pdf.text(
        projectData?.project_number,
        rightX - 70,
        topY + textOffset + 53,
        {
          align: "center",
        },
      );

      pdf.text(
        `Revision Date: ${getFormattedDate(
          deficiecncylogData[0]?.deficiency_date,
        )}`,
        rightX - 184,
        topY + textOffset + 43,
        {
          align: "center",
        },
      );

      if (i > 0) {
        // box line1
        pdf.line(
          pageWidth / 2 - 136.9,
          pageHeight - 155 + lineOffset,
          pageWidth - 12,
          pageHeight - 155 + lineOffset,
        );

        // box line 2
        pdf.line(
          pageWidth / 2 - 136.9,
          pageHeight - 143 + lineOffset,
          pageWidth - 12,
          pageHeight - 143 + lineOffset,
        );

        // first
        pdf.line(
          pageWidth / 2 - 93.5,
          pageHeight - 243 + lineOffset,
          pageWidth - 11.5,
          pageHeight - 243 + lineOffset,
        );

        // second
        pdf.line(
          pageWidth / 6 - 26.3,
          57.9,
          pageWidth / 6 - 26.3,
          pageHeight - 140,
        );

        // first
        pdf.line(
          pageWidth / 6 - 38,
          57.9,
          pageWidth / 6 - 38,
          pageHeight - 140,
        );

        // last line
        pdf.line(pageWidth - 12, 57.9, pageWidth - 12, pageHeight - 140);

        // last one
        pdf.line(pageWidth - 33, 57.9, pageWidth - 33, pageHeight - 140);

        // last second
        pdf.line(pageWidth - 56.8, 57.9, pageWidth - 56.8, pageHeight - 140);

        // third
        pdf.line(
          pageWidth / 5 - 12.1,
          57.9,
          pageWidth / 5 - 12.1,
          pageHeight - 140,
        );

        // fourth
        pdf.line(
          pageWidth / 4 - 5.8,
          57.9,
          pageWidth / 4 - 5.8,
          pageHeight - 140,
        );

        pdf.setFontSize(10);

        pdf.text(`Type Of Inspection`, rightX - 70, topY + textOffset + 62, {
          align: "center",
        });

        pdf.text(`List Of Deficiencies`, rightX - 70, topY + textOffset + 67, {
          align: "center",
        });

        pdf.text(`Deficiecy`, rightX - 188, topY + textOffset + 62, {
          align: "center",
        });

        pdf.text(`Date`, rightX - 188, topY + textOffset + 67, {
          align: "center",
        });

        pdf.text(`Def.`, rightX - 165.5, topY + textOffset + 62, {
          align: "center",
        });

        pdf.text(`PIF #`, rightX - 165.5, topY + textOffset + 67, {
          align: "center",
        });

        pdf.text(`Correction`, rightX + 30, topY + textOffset + 62, {
          align: "center",
        });

        pdf.text(`Date`, rightX + 30, topY + textOffset + 67, {
          align: "center",
        });

        pdf.text(`Corrected`, rightX + 51.2, topY + textOffset + 62, {
          align: "center",
        });

        pdf.text(`PIF  #`, rightX + 51.2, topY + textOffset + 67, {
          align: "center",
        });
      }
    }

    pdf.save(options.filename);
    setlogpdfLoading(false);
  };

  const handleClick = (inspectionData) => {
    if (inspectionData?.is_deleted == true) {
      toast.error(
        "This Inspeciton Is  deleted, you cannot Edit this Inspection",
      );
      return;
    } else {
      navigate(`/update-inspection/${inspectionData?._id}`);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DeleteInspection type="inspection" />
      <ChangeStatusOfInspection />
      <ChangeStatusBackOfInspection />
      <AddDeficiency />
      <DeleteDeficiencylog />
      <ChangeStatusOfInspectionAdmin />
      <SoftBox py={1}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              sx={{
                backgroundColor: "primary.main",
                backgroundImage: `url(${headerBg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              px={{ xs: 2, md: 3 }}
              py={2.5}
            >
              <SoftTypography color="white" variant="h6" fontSize="20px">
                <Link to="/inspections" style={{ color: "white" }}>
                  <SoftTypography
                    component="span"
                    fontWeight="light"
                    variant="h6"
                    fontSize="20px"
                  >
                    Inspections &gt;{" "}
                  </SoftTypography>
                </Link>
                Inspection Overview
              </SoftTypography>
            </SoftBox>

            {deleted == true ? (
              <SoftBox
                display="flex"
                flexDirection="column"
                height="calc(100vh - 180px)"
                alignItems="center"
                justifyContent="center"
                px={2}
              >
                <SoftTypography
                  fontSize="30px"
                  fontWeight="medium"
                  color="fade"
                  pb={2}
                >
                  This inspection is no longer available. Admins only can view
                  details.
                </SoftTypography>
                <EmptyFolderIcon style={{ opacity: 0.8 }} />
              </SoftBox>
            ) : isLoading ? (
              <SoftBox
                display="flex"
                height="calc(100vh - 180px)"
                justifyContent="center"
                alignItems="center"
                p={3}
              >
                <SoftTypography variant="subtitle1" color="textSecondary">
                  <CircularLoader type="large" />
                </SoftTypography>
              </SoftBox>
            ) : (
              <SoftBox
                sx={{ height: "calc(100vh - 190px)", overflowY: "auto" }}
              >
                <SoftBox
                  px={{ xs: 2, md: 3 }}
                  py={2}
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", lg: "row" },
                  }}
                  justifyContent="space-between"
                >
                  <SoftBox
                    sx={{
                      width: {
                        xs: "100%",
                        lg: "63%",
                      },
                      pr: {
                        sm: 5,
                      },
                    }}
                    display="flex"
                    flexDirection="column"
                    gap={1}
                  >
                    <SoftTypography
                      color="info"
                      fontWeight="bold"
                      fontSize="36px"
                      textTransform="capitalize"
                    >
                      {projectData?.name} - {projectData?.project_number}
                    </SoftTypography>

                    <SoftBox
                      sx={{
                        backgroundColor: "#F1F4F8",
                        borderRadius: "8px",
                        padding: "8px 12px",
                        marginBottom: "4px",
                        width: "100%",
                      }}
                    >
                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ minWidth: { md: 500 } }}
                        gap="8px"
                      >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                          <SoftTypography
                            fontSize="16px"
                            color="lightblack"
                            textTransform="capitalize"
                            fontWeight="bold"
                          >
                            Inspection:
                          </SoftTypography>

                          {inspectionData?.is_deleted ? (
                            <SoftTypography
                              fontSize="16px"
                              color="error"
                              textTransform="capitalize"
                              fontWeight="medium"
                            >
                              {`(Deleted ${inspectionData?.backup_inspection_number}-${inspectionData?.inspection_discipline_start})`}
                            </SoftTypography>
                          ) : (
                            <SoftTypography
                              fontSize="16px"
                              color="primary"
                              textTransform="capitalize"
                              fontWeight="medium"
                            >
                              {`${inspectionData?.inspection_number}-${inspectionData?.inspection_discipline_start}`}
                            </SoftTypography>
                          )}
                        </SoftBox>

                        <SoftTypography
                          fontSize="16px"
                          color="primary"
                          textTransform="capitalize"
                          fontWeight="medium"
                        >
                          {convertMillisecondsToDate(
                            inspectionData?.createdTime,
                          )}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>

                    <SoftBox
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "start",
                        justifyContent: "start",
                        width: "100%",
                        gap: 1,
                      }}
                    >
                      <SoftBox sx={{ width: "100%" }}>
                        <SoftTypography
                          color="lightBlack"
                          fontSize="20px"
                          fontWeight="bold"
                        >
                          Project Manager
                        </SoftTypography>

                        <SoftBox
                          color="lightBlack"
                          fontSize="16px"
                          display="flex"
                          flexDirection="column"
                          gap={2}
                          textTransform="capitalize"
                        >
                          {manager?.length > 0
                            ? manager?.map((manager, index) => (
                                <Link
                                  to={`/inspector-overview/${manager?._id}`}
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  <SoftBox
                                    key={index}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "start",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      gap: "8px",
                                      transition: "background-color 0.3s",
                                    }}
                                  >
                                    <SoftAvatar
                                      src={manager?.profile_picture || ""}
                                      alt="profile Image"
                                      size="sm"
                                      variant="rounded"
                                    />
                                    <SoftTypography
                                      className="inspector-name"
                                      variant="text"
                                      fontSize="14px"
                                      color="#212121"
                                      textTransform="capitalize"
                                    >
                                      {truncateString(manager?.full_name, 25)}
                                    </SoftTypography>
                                  </SoftBox>
                                </Link>
                              ))
                            : ""}
                        </SoftBox>
                      </SoftBox>

                      {/* Inspector details */}
                      <SoftBox
                        display="flex"
                        flexDirection="column"
                        alignItems="start"
                        justifyContent="start"
                        width="100%"
                      >
                        <SoftBox>
                          <SoftTypography
                            color="lightBlack"
                            fontSize="20px"
                            fontWeight="bold"
                          >
                            Inspector Details
                          </SoftTypography>
                        </SoftBox>

                        <SoftBox
                          display="flex"
                          width="100%"
                          alignItems="center"
                          justifyContent="space-between"
                          gap={2}
                        >
                          <SoftBox>
                            <Link
                              to={`/inspector-overview/${inspectorData?.id}`}
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              <SoftBox
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                }}
                                gap={1}
                              >
                                <SoftAvatar
                                  src={inspectorData?.image || ""}
                                  alt="profile Image"
                                  size="sm"
                                  variant="rounded"
                                />
                                <SoftTypography
                                  className="inspector-name"
                                  variant="text"
                                  fontSize="14px"
                                  color="#212121"
                                  textTransform="capitalize"
                                >
                                  {inspectorData?.name}
                                </SoftTypography>
                              </SoftBox>
                            </Link>
                          </SoftBox>
                        </SoftBox>
                      </SoftBox>

                      <SoftBox width="100%">
                        <SoftTypography
                          color="lightBlack"
                          fontSize="20px"
                          fontWeight="bold"
                        >
                          Location
                        </SoftTypography>
                        <SoftTypography
                          color="lightBlack"
                          fontSize="14px"
                          textTransform="capitalize"
                        >
                          {projectData?.location}
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>

                  {!inspectionData?.is_deleted && !projectData?.is_deleted && (
                    <SoftBox
                      display="flex"
                      py={1.5}
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="start"
                      gap={1}
                      sx={{
                        width: "37%",
                        width: {
                          xs: "100%",
                          lg: "37%",
                        },
                      }}
                    >
                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={2}
                        sx={{
                          width: "100%",
                        }}
                      >
                        <SoftButton
                          variant="gradient"
                          color="primary"
                          sx={{
                            padding: "0px",
                            width: "100%",
                            fontSize: "12px",
                            borderRadius: "8px",
                          }}
                          onClick={() => handleClick(inspectionData)}
                        >
                          Edit Inspection
                        </SoftButton>

                        <SoftButton
                          onClick={() =>
                            setDialogue({
                              type: "deleteInspection",
                              isOpen: true,
                              inspectionId: id,
                              is_deleted: true,
                              action: "deleteInspection",
                            })
                          }
                          variant="gradient"
                          color="error"
                          sx={{
                            padding: "0px",
                            width: "100%",
                            fontSize: "12px",
                            borderRadius: "8px",
                            backgroundColor: "#FF4646",
                          }}
                        >
                          Remove Inspection
                        </SoftButton>
                      </SoftBox>

                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={2}
                        sx={{
                          width: "100%",
                        }}
                      >
                        {inspectionData?.status !== "ready_for_distribution" &&
                          inspectionData?.status !== "archived" &&
                          currentUserRole == "admin" && (
                            <SoftButton
                              variant="gradient"
                              color="primary"
                              sx={{
                                padding: "0px",
                                width: "100%",
                                fontSize: "12px",
                                borderRadius: "8px",
                              }}
                              onClick={() =>
                                setDialogue({
                                  type: "changeInspectionStatusAdmin",
                                  isOpen: true,
                                  inspectionId: id,
                                  status: inspectionData?.status,
                                })
                              }
                            >
                              Approve Inspection
                            </SoftButton>
                          )}

                        {inspectionData?.status !== "archived" && (
                          <SoftButton
                            onClick={() =>
                              setDialogue({
                                type: "changeInspectionStatus",
                                isOpen: true,
                                inspectionId: id,
                                status: inspectionData?.status,
                              })
                            }
                            variant="gradient"
                            color="info"
                            sx={{
                              padding: "0px",
                              width: "100%",
                              fontSize: "12px",
                              position: "relative",
                              borderRadius: "8px",
                            }}
                          >
                            {inspectionData?.status === "new_report"
                              ? "Send to project Manager"
                              : inspectionData?.status ===
                                  "under_manager_review"
                                ? "Final Review"
                                : inspectionData?.status ===
                                    "under_editor_final_review"
                                  ? "Ready For Distribution"
                                  : inspectionData?.status ===
                                      "ready_for_distribution"
                                    ? "Archive"
                                    : ""}

                            {/* {formatStringWithSpaces(inspectionData?.status)} */}
                          </SoftButton>
                        )}

                        {inspectionData?.status == "ready_for_distribution" &&
                          inspectionData?.status !== "new_report" && (
                            <SoftButton
                              onClick={() =>
                                setDialogue({
                                  type: "changeInspectionBackStatus",
                                  isOpen: true,
                                  inspectionId: id,
                                  status: inspectionData?.status,
                                })
                              }
                              variant="gradient"
                              color="download"
                              sx={{
                                padding: "0px",
                                width: "100%",
                                fontSize: "12px",
                                backgroundColor: "#FF4646",
                                borderRadius: "8px",
                              }}
                            >
                              {inspectionData?.status === "new_report"
                                ? "Send to project Manager"
                                : inspectionData?.status ===
                                    "under_manager_review"
                                  ? "Change Status to New Report"
                                  : inspectionData?.status ===
                                      "under_editor_final_review"
                                    ? "Change Status to Manager Review"
                                    : inspectionData?.status ===
                                        "ready_for_distribution"
                                      ? "Change Status to Final Review"
                                      : inspectionData?.status === "archived"
                                        ? "Change Status to Ready for Distributionn"
                                        : ""}

                              {/* {formatStringWithSpaces(inspectionData?.status)} */}
                            </SoftButton>
                          )}
                      </SoftBox>

                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={2}
                        sx={{
                          width: "100%",
                        }}
                      >
                        {currentUserRole !== "inspector" && (
                          <SoftButton
                            variant="gradient"
                            color="preview"
                            disabled={pdfloading}
                            sx={{
                              padding: "0px",
                              width: "100%",
                              fontSize: "12px",
                              borderRadius: "8px",
                              backgroundColor: "#E8A317",
                            }}
                            onClick={() => {
                              generatePDF();
                            }}
                          >
                            {(inspectionData?.status ==
                              "ready_for_distribution" ||
                              inspectionData?.status == "archived") &&
                              !pdfloading && (
                                <MdOutlineDownload
                                  size={25}
                                  style={{ paddingRight: "3px" }}
                                />
                              )}

                            {pdfloading ? (
                              <CircularLoader type="small" />
                            ) : inspectionData?.status ==
                                "ready_for_distribution" ||
                              inspectionData?.status == "archived" ? (
                              "Download Report"
                            ) : (
                              "Preview Report"
                            )}
                          </SoftButton>
                        )}

                        {inspectionData?.status !== "new_report" &&
                          inspectionData?.status !==
                            "ready_for_distribution" && (
                            <SoftButton
                              onClick={() =>
                                setDialogue({
                                  type: "changeInspectionBackStatus",
                                  isOpen: true,
                                  inspectionId: id,
                                  status: inspectionData?.status,
                                })
                              }
                              variant="gradient"
                              color="download"
                              sx={{
                                padding: "0px",
                                width: "100%",
                                fontSize: "12px",
                                backgroundColor: "#FF4646",
                                borderRadius: "8px",
                              }}
                            >
                              {inspectionData?.status === "new_report"
                                ? "Send to project Manager"
                                : inspectionData?.status ===
                                    "under_manager_review"
                                  ? "Change Status to New Report"
                                  : inspectionData?.status ===
                                      "under_editor_final_review"
                                    ? "Change Status to Manager Review"
                                    : inspectionData?.status ===
                                        "ready_for_distribution"
                                      ? "Change Status to Final Review"
                                      : inspectionData?.status === "archived"
                                        ? "Change Status to Ready for Distributionn"
                                        : ""}

                              {/* {formatStringWithSpaces(inspectionData?.status)} */}
                            </SoftButton>
                          )}
                      </SoftBox>
                    </SoftBox>
                  )}

                  {(inspectionData?.is_deleted || projectData?.is_deleted) && (
                    <SoftBox
                      display="flex"
                      py={1.5}
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="start"
                      gap={1}
                      sx={{
                        width: "37%",
                        width: {
                          xs: "100%",
                          lg: "37%",
                        },
                      }}
                    >
                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={2}
                        sx={{
                          width: "100%",
                        }}
                      >
                        <SoftButton
                          variant="gradient"
                          color="primary"
                          sx={{
                            padding: "0px",
                            width: "80%",
                            fontSize: "12px",
                            borderRadius: "8px",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setDialogue({
                              type: "deleteInspection",
                              isOpen: true,
                              inspectionId: id,
                              is_deleted: false,
                              action: "restoreInspection",
                            });
                          }}
                        >
                          Restore Inspection
                        </SoftButton>
                      </SoftBox>
                    </SoftBox>
                  )}
                </SoftBox>

                <SoftBox
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "start",
                    justifyContent: "start",
                  }}
                  gap={1}
                  px={3}
                  pb={4}
                >
                  {projectData?.internal_notes && (
                    <SoftBox
                      border="0.5px solid #000000"
                      borderRadius="6px"
                      padding="10px"
                      maxHeight="130px"
                      height="100%"
                      sx={{
                        width: "100%",
                        overflowY: "scroll",
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": { display: "none" },
                      }}
                    >
                      <SoftTypography
                        color="lightBlack"
                        fontSize="16px"
                        fontWeight="bold"
                      >
                        Internal Notes
                      </SoftTypography>
                      <SoftTypography
                        color="lightBlack"
                        fontSize="10px"
                        fontWeight="medium"
                        paddingTop="5px"
                      >
                        {projectData?.internal_notes}
                      </SoftTypography>
                    </SoftBox>
                  )}

                  {links?.length > 0 && (
                    <SoftBox
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SoftTypography
                        color="lightBlack"
                        fontSize="20px"
                        fontWeight="bold"
                      >
                        Project Links
                      </SoftTypography>
                      {links?.map((link, index) => (
                        <SoftTypography
                          key={index}
                          color="primary"
                          fontSize="14px"
                          display="block" // ✅ Ensures text wraps next to the icon
                          flexWrap="wrap"
                          alignItems="start"
                          justifyContent="start"
                          sx={{
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "100%",
                          }}
                        >
                          <Link
                            to={link}
                            target="_blank"
                            sx={{ textDecoration: "none", color: "inherit" }}
                          >
                            <SoftBox
                              display="flex"
                              justifyContent="start"
                              alignItems="center"
                              sx={{
                                color: "primary.main",
                                width: "fit-content",
                              }}
                            >
                              <LinkIcon
                                sx={{
                                  color: "primary.main",
                                  marginRight: "8px",
                                  width: 16,
                                  height: 16,
                                  transform: "rotate(-40deg)",
                                  flexShrink: 0,
                                }}
                              />
                              {link}
                            </SoftBox>
                          </Link>
                        </SoftTypography>
                      ))}
                    </SoftBox>
                  )}

                  {contacts?.length > 0 && (
                    <SoftBox
                      sx={{
                        width: "100%",
                      }}
                    >
                      <SoftTypography
                        color="#212121"
                        fontSize="20px"
                        fontWeight="bold"
                      >
                        Project Contacts
                      </SoftTypography>
                      {contacts?.map((contact, index) => (
                        <SoftBox
                          key={index}
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{
                            backgroundColor: "#F1F4F8",
                            borderRadius: "8px",
                            padding: "5px 8px",
                            marginBottom: "4px",
                            overflowX: "auto",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": { display: "none" },
                          }}
                        >
                          <SoftBox
                            display="flex"
                            flexDirection="column"
                            color="primary"
                          >
                            <SoftBox
                              display="flex"
                              alignItems="center"
                              justifyContent="start"
                              gap="8px"
                            >
                              <SoftTypography
                                fontSize="14px"
                                color="primary"
                                textTransform="uppercase"
                                fontWeight="medium"
                              >
                                {contact?.name}
                              </SoftTypography>

                              <SoftTypography
                                fontSize="12px"
                                color="primary"
                                textTransform="capitalize"
                                fontWeight="medium"
                              >
                                {contact?.companyName}
                              </SoftTypography>
                            </SoftBox>

                            <SoftBox display="flex" gap="8px">
                              {contact?.email && (
                                <a
                                  href={`mailto:${contact?.email}`}
                                  sx={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  <SoftBox
                                    display="flex"
                                    gap="8px"
                                    color="primary"
                                  >
                                    <EmailIcon color="primary" />
                                    <SoftTypography
                                      fontSize="14px"
                                      color="primary"
                                    >
                                      {contact?.email}
                                    </SoftTypography>
                                  </SoftBox>
                                </a>
                              )}

                              {contact?.phoneNo && (
                                <SoftBox
                                  display="flex"
                                  gap="8px"
                                  color="primary"
                                >
                                  <PhoneIcon color="primary" />
                                  <SoftTypography
                                    fontSize="14px"
                                    color="primary"
                                  >
                                    {contact?.country_code}{" "}
                                    {formatPhoneNumber(contact?.phoneNo)}
                                  </SoftTypography>
                                </SoftBox>
                              )}
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                      ))}
                    </SoftBox>
                  )}
                </SoftBox>

                <SoftBox px={2} pb={3}>
                  <SoftBox
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={2}
                    sx={{
                      overflowX: "scroll",
                      scrollbarWidth: "none",
                      "&::-webkit-scrollbar": { display: "none" },
                    }}
                  >
                    {/* left side */}
                    <SoftBox display="flex" pl={1} gap={3}>
                      <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        py={1}
                        px={2}
                        sx={{
                          border: showInspections
                            ? "2px solid #02255B"
                            : "2px solid #737373",
                          backgroundColor: showInspections
                            ? "#02255B"
                            : "#F1F4F8",
                          borderTopLeftRadius: "15px",
                          borderTopRightRadius: "15px",
                          cursor: "pointer",
                          borderBottom: "none",
                        }}
                        onClick={() => setShowInspections(true)}
                      >
                        <SoftTypography
                          color={showInspections ? "white" : "text"}
                          fontWeight="medium"
                          fontSize="16px"
                        >
                          Inspection Report
                        </SoftTypography>
                      </SoftBox>

                      <SoftBox
                        py={1}
                        px={2}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          borderTopLeftRadius: "15px",
                          borderTopRightRadius: "15px",
                          cursor: "pointer",
                          border: !showInspections
                            ? "2px solid #02255B"
                            : "2px solid #737373",
                          backgroundColor: !showInspections
                            ? "#02255B"
                            : "#F1F4F8",
                          borderTopLeftRadius: "15px",
                          borderTopRightRadius: "15px",
                          cursor: "pointer",
                          borderBottom: "none",
                        }}
                        onClick={() => setShowInspections(false)}
                      >
                        <SoftTypography
                          color={!showInspections ? "white" : "text"}
                          fontWeight="medium"
                          fontSize="18px"
                        >
                          Deficiency Logs
                        </SoftTypography>
                      </SoftBox>
                    </SoftBox>

                    {/* right side */}
                    {!showInspections && (
                      <SoftBox display="flex" gap={2} pb={1}>
                        <SoftButton
                          variant="contained"
                          color="info"
                          sx={{
                            padding: "7px 12px",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                          onClick={() =>
                            setDialogue({
                              type: "AddDeficiency",
                              isOpen: true,
                              isEdit: false,
                              action: "addInspectionlog",
                              inspectionId: "",
                              projectId: projectData?._id,
                            })
                          }
                        >
                          Add <FaPlus size={14} />
                        </SoftButton>

                        <SoftButton
                          variant="contained"
                          color="yellow"
                          disabled={logpdfLoading}
                          sx={{
                            padding: "7px 12px",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                            width: "180px",
                            gap: 1,
                          }}
                          onClick={() =>
                            downloadDeficiencylogData?.length > 0
                              ? generateDeficiencyPDF()
                              : toast.error(
                                  "There is no deficiency log to download.",
                                )
                          }
                        >
                          {logpdfLoading ? (
                            <CircularLoader type="small" />
                          ) : (
                            <>
                              Download Logs <MdOutlineDownload size={25} />
                            </>
                          )}
                        </SoftButton>
                      </SoftBox>
                    )}
                  </SoftBox>

                  {/* Inspection Information */}
                  {showInspections && (
                    <SoftBox
                      borderRadius="10px"
                      border="1px solid #02255B"
                      overflow="hidden"
                    >
                      <SoftBox>
                        <SoftBox
                          display="flex"
                          sx={{
                            flexDirection: { xs: "column", sm: "row" },
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                          }}
                          py={1}
                          borderBottom="1px solid #02255B"
                          backgroundColor="#F1F4F8"
                        >
                          {weatherData?.map(
                            (item, index) =>
                              inspectionData && (
                                <SoftBox
                                  px={2}
                                  key={index}
                                  display="flex"
                                  sx={{
                                    flexDirection: { xs: "column", sm: "row" },
                                    alignItems:
                                      item?.label == "Weather Condition"
                                        ? "start"
                                        : "center",
                                    justifyContent:
                                      item?.label == "Weather Condition"
                                        ? "start"
                                        : "center",
                                  }}
                                  width="25%"
                                >
                                  <SoftTypography
                                    color="lightBlack"
                                    fontSize="16px"
                                    fontWeight="bold"
                                  >
                                    {item?.label}
                                  </SoftTypography>
                                </SoftBox>
                              ),
                          )}
                        </SoftBox>

                        <SoftBox
                          display="flex"
                          sx={{ flexDirection: { xs: "column", sm: "row" } }}
                        >
                          {weatherData?.map(
                            (item, index) =>
                              inspectionData && (
                                <SoftBox
                                  px={2}
                                  key={index}
                                  display="flex"
                                  sx={{
                                    alignItems:
                                      item?.label == "Weather Condition"
                                        ? "start"
                                        : "center",
                                    justifyContent:
                                      item?.label == "Weather Condition"
                                        ? "start"
                                        : "center",
                                  }}
                                  width="25%"
                                >
                                  {item.label === "Status" ? (
                                    <SoftTypography
                                      color="primary"
                                      fontSize="16px"
                                      fontWeight="bold"
                                      mt={0.5}
                                    >
                                      {inspectionData?.status ==
                                      "under_manager_review"
                                        ? "Under Review"
                                        : inspectionData?.status ==
                                            "under_editor_final_review"
                                          ? "Final Review"
                                          : formatStringWithSpaces(
                                              inspectionData?.status,
                                            )}
                                    </SoftTypography>
                                  ) : item.label === "Weather Condition" ? (
                                    <SoftTypography
                                      color="lightblack"
                                      fontSize="16px"
                                      fontWeight="regular"
                                      textTransform="capitalize"
                                    >
                                      {inspectionData?.weather_condition}
                                    </SoftTypography>
                                  ) : item.label === "Temperature" ? (
                                    <SoftTypography
                                      color="lightblack"
                                      fontSize="16px"
                                      fontWeight="regular"
                                      display="flex"
                                      mt={0.5}
                                    >
                                      {inspectionData?.temperature}
                                      <SoftTypography fontWeight="dark">
                                        <PanoramaFishEyeIcon
                                          sx={{
                                            marginLeft: "1px",
                                            marginBottom: "14px",
                                            width: 7,
                                            height: 7,
                                            filter: "brightness(0) contrast(9)",
                                          }}
                                        />
                                      </SoftTypography>
                                      F
                                    </SoftTypography>
                                  ) : item.label === "Deficiencies Found" ? (
                                    <SoftTypography
                                      color="lightblack"
                                      fontSize="16px"
                                      fontWeight="regular"
                                      textTransform="uppercase"
                                      mt={0.5}
                                    >
                                      {formatStringWithSpaces(
                                        inspectionData?.deficiencies_found.join(
                                          ", ",
                                        ),
                                      )}
                                    </SoftTypography>
                                  ) : null}
                                </SoftBox>
                              ),
                          )}
                        </SoftBox>
                      </SoftBox>

                      {/* Time Arrived Time Left */}
                      <SoftBox
                        display="flex"
                        justifyContent="space-between"
                        sx={{ flexDirection: { xs: "column", sm: "row" } }}
                        gap={2}
                        pb={5}
                        pt={1}
                        px={2}
                      >
                        <SoftBox
                          display="flex"
                          sx={{ justifyContent: { xs: "space-between" } }}
                          gap={2}
                        >
                          <SoftTypography
                            sx={{
                              textAlign: {
                                xs: "left",
                                sm: "center",
                              },
                            }}
                            color="primary"
                            fontSize="20px"
                            fontWeight="bold"
                            padding="2px 0px"
                            borderRadius="6px"
                          >
                            Inspection Date
                          </SoftTypography>
                          <SoftTypography
                            sx={{
                              textAlign: {
                                xs: "right",
                                sm: "center",
                              },
                            }}
                            backgroundColor="primary.main"
                            color="white"
                            fontSize="16px"
                            fontWeight="medium"
                            padding="5px 15px"
                            borderRadius="6px"
                          >
                            {getDateFromSeconds(inspectionData?.inspectionTime)}
                          </SoftTypography>
                        </SoftBox>

                        <SoftTypography
                          display="flex"
                          sx={{ justifyContent: { xs: "space-between" } }}
                          gap={2}
                        >
                          <SoftTypography
                            sx={{
                              textAlign: {
                                xs: "left",
                                sm: "center",
                              },
                            }}
                            color="primary"
                            fontSize="20px"
                            fontWeight="bold"
                            padding="2px 0px"
                            borderRadius="6px"
                          >
                            Time Arrived
                          </SoftTypography>

                          <SoftTypography
                            sx={{
                              textAlign: {
                                xs: "right",
                                sm: "center",
                              },
                            }}
                            backgroundColor="primary.main"
                            color="white"
                            fontSize="16px"
                            fontWeight="medium"
                            padding="5px 15px"
                            borderRadius="6px"
                          >
                            {getTimeFromMilliseconds(
                              inspectionData?.arrival_time,
                            )}
                          </SoftTypography>
                        </SoftTypography>

                        <SoftBox
                          display="flex"
                          sx={{ justifyContent: { xs: "space-between" } }}
                          gap={2}
                        >
                          <SoftTypography
                            sx={{
                              textAlign: {
                                xs: "left",
                                sm: "center",
                              },
                            }}
                            color="primary"
                            fontSize="20px"
                            fontWeight="bold"
                            padding="2px 0px"
                            borderRadius="6px"
                          >
                            Time Left
                          </SoftTypography>
                          <SoftTypography
                            sx={{
                              textAlign: {
                                xs: "right",
                                sm: "center",
                              },
                            }}
                            backgroundColor="primary.main"
                            color="white"
                            fontSize="16px"
                            fontWeight="medium"
                            padding="5px 15px"
                            borderRadius="6px"
                          >
                            {getTimeFromMilliseconds(inspectionData?.time_left)}
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>

                      {/* Site Representative */}
                      {inspectionData?.app_site_representative?.length > 0 && (
                        <SoftBox
                          px={2}
                          display="flex"
                          flexDirection="column"
                          gap={1}
                        >
                          <SoftBox
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <SoftTypography fontSize="16px" fontWeight="bold">
                              Site Representative
                            </SoftTypography>
                          </SoftBox>

                          <SoftBox>
                            <Grid container spacing={2}>
                              {inspectionData?.app_site_representative?.length >
                                0 &&
                                inspectionData?.app_site_representative?.map(
                                  (contact, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                      <SoftBox
                                        display="flex"
                                        alignItems="center"
                                        sx={{
                                          backgroundColor: "#F1F4F8",
                                          borderRadius: "6px",
                                          padding: "5px 8px",
                                          marginBottom: "4px",
                                          overflowX: "auto",
                                          overflowY: "hidden",
                                          whiteSpace: "nowrap",
                                          scrollbarWidth: "none",
                                          "&::-webkit-scrollbar": {
                                            display: "none",
                                          },
                                        }}
                                      >
                                        <SoftBox
                                          display="flex"
                                          flexDirection="column"
                                          color="primary"
                                        >
                                          <SoftBox
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="start"
                                            py={1}
                                            gap={1}
                                          >
                                            <SoftTypography
                                              fontSize="14px"
                                              color="primary"
                                              textTransform="uppercase"
                                              fontWeight="medium"
                                            >
                                              {contact.name}
                                            </SoftTypography>

                                            <SoftTypography
                                              fontSize="12px"
                                              color="primary"
                                              textTransform="capitalize"
                                              fontWeight="medium"
                                            >
                                              {contact.companyName}
                                            </SoftTypography>
                                          </SoftBox>
                                        </SoftBox>
                                      </SoftBox>
                                    </Grid>
                                  ),
                                )}
                            </Grid>
                          </SoftBox>
                        </SoftBox>
                      )}

                      {/* Reinspection Information */}
                      {referenceData &&
                        Object?.keys(referenceData)?.length !== 0 && (
                          <SoftBox>
                            <SoftBox backgroundColor="shadow.main">
                              <SoftTypography
                                textAlign="center"
                                backgroundColor="primary.main"
                                color="white"
                                fontSize="20px"
                                fontWeight="medium"
                                padding="2px 15px"
                              >
                                Re - Inspection Information
                              </SoftTypography>

                              <SoftBox
                                display="flex"
                                px={3}
                                justifyContent="space-between"
                                py={1}
                                sx={{
                                  flexDirection: { xs: "column", sm: "row" },
                                }}
                              >
                                {InspectionData?.map((item, index) => (
                                  <SoftBox
                                    key={index}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    gap={2}
                                  >
                                    <SoftTypography
                                      color="lightBlack"
                                      fontSize="16px"
                                      fontWeight="bold"
                                    >
                                      {item?.label}
                                    </SoftTypography>

                                    {item?.label === "Inspection Number" ? (
                                      <SoftTypography
                                        color="lightblack"
                                        fontSize="16px"
                                        fontWeight="regular"
                                      >
                                        {referenceData?.inspection_number}
                                      </SoftTypography>
                                    ) : item.label === "Temperature" ? (
                                      <SoftTypography
                                        color="lightblack"
                                        fontSize="16px"
                                        fontWeight="regular"
                                        display="flex"
                                      >
                                        {referenceData?.temperature}
                                        <SoftTypography fontWeight="dark">
                                          <PanoramaFishEyeIcon
                                            sx={{
                                              marginLeft: "1px",
                                              marginBottom: "14px",
                                              width: 7,
                                              height: 7,
                                              filter:
                                                "brightness(0) contrast(9)",
                                            }}
                                          />
                                        </SoftTypography>
                                        F
                                      </SoftTypography>
                                    ) : (
                                      <SoftTypography
                                        color="lightblack"
                                        fontSize="16px"
                                        fontWeight="regular"
                                      >
                                        {formatStringWithSpaces(
                                          referenceData?.deficiencies_found.join(
                                            ", ",
                                          ),
                                        )}
                                      </SoftTypography>
                                    )}
                                  </SoftBox>
                                ))}

                                <Link
                                  to={`/inspection-overview/${referenceData?._id}`}
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  <ChevronRightIcon
                                    sx={{
                                      width: 28,
                                      height: 28,
                                    }}
                                  />
                                </Link>
                              </SoftBox>
                            </SoftBox>
                          </SoftBox>
                        )}

                      {/* Discipline Data */}

                      {discipline && (
                        <SoftBox
                          display="flex"
                          flexDirection="column"
                          gap={1}
                          mt={1}
                        >
                          {discipline?.map((item, index) => (
                            <InspectionSection
                              key={index}
                              indexAlphabet={
                                discipline?.length > 1 &&
                                `${String.fromCharCode(65 + index)})`
                              }
                              title={item?.disciplineName}
                              subtitle={item?.location}
                              comments={item?.comment}
                              notes={item?.notes}
                              inspectionType={item?.inspectionType}
                              images={item?.images}
                              PifNumber={PifNumber}
                              deficiencyFound={
                                inspectionData?.deficiencies_found
                              }
                            />
                          ))}
                        </SoftBox>
                      )}
                    </SoftBox>
                  )}

                  {!showInspections &&
                    (deficiencyRows?.length > 0 ? (
                      <>
                        <SoftBox border="1px solid #02255B" borderRadius="10px">
                          {deficiencylogLoading ? (
                            <SoftBox
                              display="flex"
                              height="100%"
                              justifyContent="center"
                              alignItems="center"
                              p={3}
                            >
                              <SoftTypography
                                variant="subtitle1"
                                color="textSecondary"
                              >
                                <CircularLoader type="large" />
                              </SoftTypography>
                            </SoftBox>
                          ) : (
                            <CustomTable
                              columns={Deficiencycolumns}
                              rows={deficiencyRows}
                              radius={true}
                              whitebackground={true}
                            />
                          )}
                        </SoftBox>

                        <SoftBox
                          py={1}
                          sx={{
                            backgroundColor: "#ffffff",
                            bottom: 0,
                            zIndex: 2,
                          }}
                        >
                          <SoftPagination
                            Totalpages={pagination?.totalPages}
                            currentPage={page}
                            changePage={setPage}
                          />
                        </SoftBox>
                      </>
                    ) : (
                      <SoftBox
                        sx={{
                          border: "1px solid #02255B",
                          borderRadius: "9px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <SoftBox
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          alignItems="center"
                          width="100%"
                          borderRadius="9px"
                        >
                          <SoftBox
                            display="flex"
                            justifyContent="space-between"
                            width="100%"
                            backgroundColor="shadow.main"
                            sx={{
                              borderTopRightRadius: "9px",
                              borderTopLeftRadius: "9px",
                              overflowX: "scroll",
                              scrollbarWidth: "none",
                              "&::-webkit-scrollbar": { display: "none" },
                            }}
                          >
                            {Deficiencycolumns.map(
                              ({ name, align, width }, index) => (
                                <SoftBox
                                  key={index}
                                  width={width}
                                  align={align}
                                  fontWeight="bold"
                                  fontSize="16px"
                                  py="14px"
                                  px="24px"
                                >
                                  {name}
                                </SoftBox>
                              ),
                            )}
                          </SoftBox>
                          <SoftTypography
                            fontSize="60px"
                            fontWeight="light"
                            height="70px"
                            color="fade"
                          >
                            0
                          </SoftTypography>
                          <SoftTypography
                            fontSize="25px"
                            fontWeight="medium"
                            color="fade"
                            pb={1.5}
                          >
                            Deficiency logs
                          </SoftTypography>
                          <EmptyFolderIcon
                            style={{
                              opacity: 0.8,
                            }}
                          />
                        </SoftBox>
                      </SoftBox>
                    ))}
                </SoftBox>
              </SoftBox>
            )}
          </Card>
        </SoftBox>
      </SoftBox>

      {/* deficiency  pdf block */}
      <SoftBox sx={{ display: "none" }}>
        <Container
          ref={deficiencypdfRef}
          py={4}
          maxWidth={false}
          sx={{ width: "100%" }}
        >
          <Table
            sx={{ width: "1035px", tableLayout: "fixed" }}
            aria-label="deficiency log table"
          >
            {downloadDeficiencylogData?.map((row, index) => (
              <TableRow
                key={row?.id}
                sx={{
                  backgroundColor: !row?.corrected_inspection_id
                    ?.inspection_number
                    ? "#F8FE01"
                    : "white",

                  "& td": {
                    paddingTop: 0,
                    paddingBottom: 0,
                  },
                }}
              >
                <TableCell
                  sx={{
                    borderRight: "1px solid #000000",
                    borderBottom: "1px solid #000000",
                    borderLeft: "1px solid #000000",
                    px: 1,
                    width: "45px",
                    verticalAlign: "top", // aligns content to the top vertically
                    textAlign: "center", // centers text horizontally
                  }}
                >
                  <SoftTypography fontSize="12px" fontWeight="bold">
                    {index + 1}
                  </SoftTypography>
                </TableCell>

                <TableCell
                  sx={{
                    borderBottom: "1px solid #000000",
                    p: 0,
                    width: "90px",
                    verticalAlign: "top", // aligns content to the top vertically
                    textAlign: "center",
                  }}
                  align="center"
                >
                  <SoftTypography fontSize="12px" fontWeight="bold">
                    {row?.deficiency_date !== 0
                      ? getFormattedDate(row?.deficiency_date)
                      : ""}
                  </SoftTypography>
                </TableCell>

                <TableCell
                  sx={{
                    borderBottom: "1px solid #000000",
                    borderLeft: "1px solid #000000",
                    p: 0,
                    width: "80px",
                    verticalAlign: "top", // aligns content to the top vertically
                    textAlign: "center",
                  }}
                  align="center"
                >
                  <SoftTypography fontSize="12px" fontWeight="bold">
                    {row?.deficiency_inspection_id?.inspection_number}-
                    {row?.deficiency_inspection_id?.inspection_discipline_start}
                  </SoftTypography>
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #000000",
                    borderBottom: "1px solid #000000",
                    borderLeft: "1px solid #000000",
                    width: "650px",
                    px: 1,
                  }}
                  align="left"
                >
                  <SoftTypography fontSize="12px" fontWeight="bold">
                    {row?.inspection_type}
                  </SoftTypography>

                  {row?.location && (
                    <SoftTypography fontSize="12px" fontWeight="bold">
                      Location : {row?.location}
                    </SoftTypography>
                  )}

                  {row?.list_of_dependencies?.map((item, idx) => (
                    <SoftTypography key={idx} fontSize="12px">
                      {item}
                    </SoftTypography>
                  ))}
                </TableCell>

                <TableCell
                  sx={{
                    borderBottom: "1px solid #000000",
                    p: 0,
                    widht: "90px",
                    verticalAlign: "top", // aligns content to the top vertically
                    textAlign: "center",
                  }}
                  align="center"
                >
                  <SoftTypography fontSize="12px" fontWeight="bold">
                    {row?.corrected_date !== 0
                      ? getFormattedDate(row?.corrected_date)
                      : ""}
                  </SoftTypography>
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #000000",
                    borderBottom: "1px solid #000000",
                    borderLeft: "1px solid #000000",
                    p: 0,
                    width: "80px",
                    verticalAlign: "top", // aligns content to the top vertically
                    textAlign: "center",
                  }}
                  align="center"
                >
                  <SoftTypography fontSize="12px" fontWeight="bold">
                    {row?.corrected_inspection_id?.inspection_number}-
                    {row?.corrected_inspection_id?.inspection_discipline_start}
                  </SoftTypography>
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </Container>
      </SoftBox>

      {/*  inspection pdf*/}
      <SoftBox
        sx={{ display: "none" }}
        width="794px"
        minWidth="794px"
        maxWidth="794px"
      >
        <Container ref={contentRef} maxWidth="md">
          {/* Header */}
          <SoftBox display="flex" alignItems="center">
            <SoftBox width="100%" textAlign="center">
              {brand && (
                <SoftBox
                  component="img"
                  src={brand}
                  alt="Soft UI Logo"
                  width="9rem"
                />
              )}
              <SoftTypography
                color="#000000"
                fontSize="8px"
                fontWeight="bold"
                sx={{ lineHeight: "15px" }}
                mt={-2}
              >
                {" "}
                Helping Ensure a Safer Built Environment{" "}
              </SoftTypography>
            </SoftBox>
          </SoftBox>

          {/* pdf data i table */}
          <SoftBox py={1} pt={1}>
            <Table>
              <TableBody>
                {pfdData?.map((contact, index) => (
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{
                        backgroundColor: "#D9D9D9",
                        width: "25%",
                        border: "1px solid #000000",
                        borderBottom: index !== 0 ? "" : "none !important",
                        borderRight: "none !important",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="normal"
                      >
                        {contact.name}{" "}
                      </SoftTypography>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        border: "1px solid #000000",
                        borderBottom: index !== 0 ? "" : "none !important",
                        borderRight: "none !important",
                        borderLeft: "none !important",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="medium"
                      >
                        {contact?.email}{" "}
                      </SoftTypography>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        backgroundColor: "#D9D9D9",
                        borderBottom: index !== 0 ? "" : "none !important",
                        border: "1px solid #000000",
                        borderRight: "none !important",
                        borderLeft: "none !important",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="normal"
                      >
                        {contact?.phone}{" "}
                      </SoftTypography>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        border: "1px solid #000000",
                        borderBottom: index !== 0 ? "" : "none !important",
                        borderLeft: "none !important",
                      }} // Set consistent width
                    >
                      {contact.value && (
                        <SoftTypography
                          sx={{ color: "#000000" }}
                          fontSize="12px"
                          fontWeight="bold"
                        >
                          {contact.value}{" "}
                        </SoftTypography>
                      )}
                      {contact?.temp && (
                        <SoftTypography
                          sx={{ color: "#000000" }}
                          fontSize="12px"
                          fontWeight="bold"
                          display="flex"
                          position="relative"
                        >
                          {contact?.temp}
                          <SoftTypography
                            sx={{ color: "#000000" }}
                            fontSize="12px"
                            fontWeight="bold"
                            display="flex"
                            position="relative"
                          >
                            °F
                          </SoftTypography>
                        </SoftTypography>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </SoftBox>

          {/* pdf data 2 table */}
          <SoftBox py={1} pt={1}>
            <Table>
              <TableBody>
                {pdfdata2?.map((contact, index) => (
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{
                        borderBottom: "none !important",
                        borderRight: "none !important",
                        border: "1px solid #000000",
                        width: "25%",
                        backgroundColor: "#D9D9D9",
                        borderCollapse: "collapse",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="normal"
                      >
                        {contact?.name}{" "}
                      </SoftTypography>
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        borderBottom: "none !important",
                        borderRight: "none !important",
                        borderTop: "1px solid #000000",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="medium"
                      >
                        {contact?.email}{" "}
                      </SoftTypography>
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        backgroundColor: "#D9D9D9",
                        borderRight: "none !important",
                        borderLeft: "none !important",
                        borderBottom: "none !important",
                        border: "1px solid #000000",
                      }} // Set consistent width
                    >
                      <SoftTypography
                        sx={{ color: "#000000" }}
                        fontSize="12px"
                        fontWeight="normal"
                      >
                        {contact?.phone}{" "}
                      </SoftTypography>
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        width: "25%",
                        borderBottom: "none !important",
                        borderLeft: "none !important",
                        border: "1px solid #000000",
                      }} // Set consistent width
                    >
                      {contact.value && (
                        <SoftTypography
                          sx={{ color: "#000000" }}
                          fontSize="12px"
                          fontWeight="bold"
                        >
                          {contact.value}{" "}
                        </SoftTypography>
                      )}
                      {contact?.temp && (
                        <SoftTypography
                          sx={{ color: "#000000" }}
                          fontSize="12px"
                          fontWeight="bold"
                          display="flex"
                          position="relative"
                        >
                          {contact?.temp}
                          <SoftTypography
                            sx={{ color: "#000000" }}
                            fontSize="12px"
                            fontWeight="bold"
                            display="flex"
                            position="relative"
                          >
                            °F
                          </SoftTypography>
                        </SoftTypography>
                      )}
                    </TableCell>
                  </TableRow>
                ))}

                <TableCell
                  align="left"
                  sx={{
                    backgroundColor: "#D9D9D9",
                    width: "25%",
                    borderRight: "none !important",
                    border: "1px solid #000000",
                  }} // Set consistent width
                >
                  <SoftTypography
                    sx={{ color: "#000000" }}
                    fontSize="12px"
                    fontWeight="normal"
                  >
                    Deficiencies Found:
                  </SoftTypography>
                </TableCell>

                <TableCell
                  colSpan={3}
                  sx={{
                    paddingTop: 0,
                    paddingBottom: 0,
                    borderLeft: "none !important",
                    border: "1px solid #000000",
                  }}
                >
                  <SoftBox
                    display="flex"
                    alignItems="start"
                    justifyContent="start"
                    gap={6}
                  >
                    <SoftBox
                      display="flex"
                      gap="2px"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <SoftBox position="relative" mt={0.5} mr={0.5}>
                        {inspectionData?.deficiencies_found?.includes("no") ? (
                          <SoftBox
                            component="img"
                            src={checkboxgreen}
                            sx={{
                              width: 15,
                              height: 15,
                              objectFit: "cover",
                              borderRadius: "2px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <SoftBox
                            component="img"
                            src={checkboxwhite}
                            sx={{
                              width: 15,
                              height: 15,
                              objectFit: "cover",
                              borderRadius: "2px",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </SoftBox>

                      <SoftTypography
                        color="lightBlack"
                        fontSize="14px"
                        fontWeight="medium"
                        display="flex"
                        sx={{ color: "#212121" }}
                      >
                        No
                      </SoftTypography>
                    </SoftBox>

                    <SoftBox
                      display="flex"
                      gap="2px"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <SoftBox position="relative" mt={0.5} mr={0.5}>
                        {inspectionData?.deficiencies_found?.includes("yes") ? (
                          <SoftBox
                            component="img"
                            src={checkboxgreen}
                            sx={{
                              width: 15,
                              height: 15,
                              objectFit: "cover",
                              borderRadius: "2px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <SoftBox
                            component="img"
                            src={checkboxwhite}
                            sx={{
                              width: 15,
                              height: 15,
                              objectFit: "cover",
                              borderRadius: "2px",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </SoftBox>

                      <SoftTypography
                        color="lightBlack"
                        fontSize="14px"
                        fontWeight="medium"
                        display="flex"
                        sx={{ color: "#212121" }}
                      >
                        Yes
                        <SoftTypography
                          color="lightBlack"
                          fontSize="14px"
                          fontWeight="regular"
                          display="flex"
                          sx={{ color: "#212121" }}
                        >
                          (see comments below)
                        </SoftTypography>
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </TableCell>
              </TableBody>
            </Table>
          </SoftBox>

          {/* Site Representative */}
          {inspectionData?.app_site_representative?.length > 0 && (
            <SoftBox py={1}>
              <SoftTypography variant="h6" size="14px" fontWeight="bold" py={1}>
                Site Representative
              </SoftTypography>
              <Table
                sx={{
                  tableLayout: "fixed",
                  width: "100%",
                }}
                my={2}
              >
                <TableBody>
                  {inspectionData?.app_site_representative?.length > 0 &&
                    inspectionData?.app_site_representative?.map(
                      (contact, index) => (
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{
                              borderRight: "none !important",
                              border: "1px solid #000000",
                              backgroundColor: "#D9D9D9",
                            }}
                          >
                            <SoftTypography
                              sx={{ color: "#000000" }}
                              fontSize="12px"
                              fontWeight="normal"
                            >
                              Name
                            </SoftTypography>
                          </TableCell>

                          <TableCell
                            align="left"
                            sx={{
                              borderLeft: "none !important",
                              borderRight: "none !important",
                              border: "1px solid #000000",
                            }}
                          >
                            <SoftTypography
                              sx={{ color: "#000000" }}
                              fontSize="12px"
                              fontWeight="normal"
                            >
                              {contact.name}
                            </SoftTypography>
                          </TableCell>

                          <TableCell
                            align="left"
                            sx={{
                              borderLeft: "none !important",
                              borderRight: "none !important",
                              border: "1px solid #000000",
                              backgroundColor: "#D9D9D9",
                            }}
                          >
                            <SoftTypography
                              sx={{ color: "#000000" }}
                              fontSize="12px"
                              fontWeight="normal"
                            >
                              Company Name
                            </SoftTypography>
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              borderLeft: "none !important",
                              border: "1px solid #000000",
                            }}
                          >
                            <SoftTypography
                              sx={{ color: "#000000" }}
                              fontSize="12px"
                              fontWeight="normal"
                            >
                              {contact?.companyName}
                            </SoftTypography>
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                </TableBody>
              </Table>
            </SoftBox>
          )}

          {/* ReInspectin Requied */}

          <SoftBox
            display="flex"
            alignItems="start"
            justifyContent="start"
            gap={6}
          >
            <softBox display="flex" alignItems="center" justifyContent="center">
              <SoftTypography
                fontSize="14px"
                fontWeight="medium"
                color="#212121"
                mt={0.4}
              >
                Re-Inspection Required
              </SoftTypography>
            </softBox>

            <SoftBox
              display="flex"
              gap="2px"
              alignItems="center"
              justifyContent="center"
            >
              <SoftBox position="relative" mr={0.5}>
                {inspectionData?.deficiencies_found?.includes(
                  "reinspection_required",
                ) ? (
                  <SoftBox
                    component="img"
                    src={checkboxgreen}
                    sx={{
                      width: 15,
                      height: 15,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <SoftBox
                    component="img"
                    src={checkboxwhite}
                    sx={{
                      width: 15,
                      height: 15,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                  />
                )}
              </SoftBox>

              <SoftTypography
                color="lightBlack"
                fontSize="14px"
                fontWeight="medium"
                display="flex"
                sx={{ color: "#212121" }}
              >
                Yes
              </SoftTypography>
            </SoftBox>

            <SoftBox
              display="flex"
              gap="2px"
              alignItems="center"
              justifyContent="center"
            >
              <SoftBox position="relative" mr={0.5}>
                {!inspectionData?.deficiencies_found?.includes(
                  "reinspection_required",
                ) ? (
                  <SoftBox
                    component="img"
                    src={checkboxgreen}
                    sx={{
                      width: 15,
                      height: 15,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <SoftBox
                    component="img"
                    src={checkboxwhite}
                    sx={{
                      width: 15,
                      height: 15,
                      objectFit: "cover",
                      borderRadius: "2px",
                      cursor: "pointer",
                    }}
                  />
                )}
              </SoftBox>

              <SoftTypography
                color="lightBlack"
                fontSize="14px"
                fontWeight="medium"
                display="flex"
                sx={{ color: "#212121" }}
              >
                No
              </SoftTypography>
            </SoftBox>
          </SoftBox>

          {/* Disciplinne section */}

          {discipline?.length > 0 &&
            discipline?.map((disciplineData, index) => (
              <React.Fragment key={index}>
                <SoftBox>
                  <SoftTypography
                    variant="h6"
                    fontSize="18px"
                    fontWeight="bold"
                  >
                    {discipline?.length > 1 &&
                      `${String.fromCharCode(65 + index)})`}{" "}
                    Discipline : {disciplineData?.disciplineName}
                  </SoftTypography>
                </SoftBox>

                {disciplineData?.inspectionType && (
                  <SoftBox
                    sx={{ breakInside: "auto", pageBreakInside: "auto" }}
                  >
                    <SoftTypography
                      fontSize="14px"
                      fontWeight="regular"
                      color="#212121"
                      sx={{ breakInside: "auto", pageBreakInside: "auto" }}
                    >
                      <strong fontWeight="medium"> Inspection Type : </strong>{" "}
                      {disciplineData?.inspectionType}
                    </SoftTypography>
                  </SoftBox>
                )}

                {disciplineData?.location && (
                  <SoftBox
                    sx={{ breakInside: "auto", pageBreakInside: "auto" }}
                  >
                    <SoftTypography
                      fontSize="14px"
                      fontWeight="regular"
                      color="#212121"
                      sx={{ breakInside: "auto", pageBreakInside: "auto" }}
                    >
                      <strong fontWeight="medium"> Location : </strong>
                      {disciplineData?.location}
                    </SoftTypography>
                  </SoftBox>
                )}

                {disciplineData?.comment && (
                  <SoftBox
                    sx={{
                      breakInside: "auto",
                      pageBreakInside: "auto !important",
                      pageBreakBefore: "auto  !important",
                      pageBreakAfter: "auto  !important",
                      display: "block",
                    }}
                  >
                    {disciplineData.comment
                      .split("\n")
                      .map((comment, index) => (
                        <SoftTypography
                          key={index}
                          fontSize="14px"
                          fontWeight="regular"
                          sx={{
                            breakInside: "avoid",
                            pageBreakInside: "avoid !important",
                            pageBreakBefore: "avoid  !important",
                            pageBreakAfter: "avoid  !important",
                            display: "block",
                            whiteSpace: "pre-line",
                          }}
                          color="#212121"
                        >
                          {index == 0 && (
                            <strong fontWeight="medium"> Comments : </strong>
                          )}

                          {comment}
                        </SoftTypography>
                      ))}
                  </SoftBox>
                )}

                {PifNumber?.type && (
                  <SoftBox
                    component="table"
                    sx={{
                      borderCollapse: "collapse",
                      width: "auto",
                      maxWidth: "100%",
                      my: 1,
                      breakInside: "avoid",
                      pageBreakInside: "avoid !important",
                      WebkitColumnBreakInside: "avoid",
                    }}
                  >
                    <SoftBox component="tbody">
                      <SoftBox component="tr">
                        <SoftBox
                          component="td"
                          sx={{
                            border: "none",
                            p: 0,
                            pr: 0.5,
                            verticalAlign: "top",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <SoftTypography
                            fontSize="14px"
                            fontWeight="bold"
                            color="#212121"
                          >
                            {PifNumber?.type == "corrected_pif"
                              ? "PIF Corrected Number :"
                              : "PIF Replace Number :"}
                          </SoftTypography>
                        </SoftBox>
                        <SoftBox
                          component="td"
                          sx={{
                            border: "none",
                            p: 0,
                            verticalAlign: "top",
                          }}
                        >
                         <SoftBox
  backgroundColor="#F8FE01"
  px={4}
  py={0.5}
  sx={{
    display: "inline-block",
    whiteSpace: "nowrap",
    color: "#212121",
    fontSize: "14px",
  }}
>
  {PifNumber?.value}
</SoftBox>
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                )}

                {disciplineData?.notes && (
                  <SoftBox
                    sx={{
                      breakInside: "avoid",
                      pageBreakInside: "avoid !important",
                      pageBreakBefore: "avoid  !important",
                      pageBreakAfter: "avoid  !important",
                      display: "block",
                    }}
                  >
                    {disciplineData.notes.split("\n").map((note, index) => (
                      <SoftTypography
                        key={index}
                        fontSize="14px"
                        fontWeight="regular"
                        sx={{
                          breakInside: "avoid",
                          pageBreakInside: "avoid !important",
                          pageBreakBefore: "avoid  !important",
                          pageBreakAfter: "avoid  !important",
                          display: "block",
                          whiteSpace: "pre-line",
                        }}
                        color="#212121"
                      >
                        {index == 0 && (
                          <strong fontWeight="medium"> Notes : </strong>
                        )}

                        {note}
                      </SoftTypography>
                    ))}
                  </SoftBox>
                )}

                {/* Line  */}
                <SoftBox border="1px solid #212121" width="100%" my={1}>
                  {" "}
                </SoftBox>
              </React.Fragment>
            ))}

          {/* Signature Footer */}

          <SoftBox
            display="inline-block"
            width="100%"
            sx={{
              breakInside: "avoid",
              pageBreakInside: "avoid !important",
              pageBreakBefore: "avoid  !important",
              pageBreakAfter: "avoid  !important",
            }}
          >
            <SoftBox
              display="flex"
              width="100%"
              gap={3}
              sx={{
                breakInside: "avoid",
                pageBreakInside: "avoid !important",
                pageBreakBefore: "avoid  !important",
                pageBreakAfter: "avoid  !important",
              }}
            >
              {/* left box */}

              <SoftBox
                width="100%"
                display="flex"
                flexDirection="column"
                gap={1}
              >
                {/* Top */}
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SoftBox
                    display="inline-block"
                    sx={{
                      breakInside: "avoid",
                      pageBreakInside: "avoid",
                      pageBreakBefore: "avoid",
                      pageBreakAfter: "avoid",
                    }}
                  >
                    <SoftTypography
                      fontSize="14px"
                      fontWeight="medium"
                      color="#212121"
                    >
                      {" "}
                      {reviewedBy?._id
                        ? reviewedBy?.full_name
                        : manager?.[0]?.full_name}
                    </SoftTypography>
                  </SoftBox>

                  <SoftBox border="1px solid #212121" width="100%">
                    {" "}
                  </SoftBox>
                  <SoftTypography
                    fontSize="10px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    (Reviewed By - Printed Name){" "}
                  </SoftTypography>
                </SoftBox>

                {/* Bottom */}
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SoftBox
                    className="manager-signature"
                    component="img"
                    src={managerSignature}
                    alt={`Signature Image`}
                    sx={{
                      width: "30%",
                      height: "80px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                  <SoftBox border="1px solid #212121" width="100%">
                    {" "}
                  </SoftBox>
                  <SoftTypography
                    fontSize="10px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    (Reviewed By - Signature){" "}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>

              {/* Right block   */}
              <SoftBox
                width="100%"
                display="flex"
                gap={1}
                flexDirection="column"
              >
                {/* Top */}
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SoftTypography
                    fontSize="14px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    {inspectedBy?._id
                      ? inspectedBy?.full_name
                      : inspectionData?.added_by?.full_name}
                  </SoftTypography>
                  <SoftBox border="1px solid #212121" width="100%">
                    {" "}
                  </SoftBox>
                  <SoftTypography
                    fontSize="10px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    (Inspected By - Printed Name){" "}
                  </SoftTypography>
                </SoftBox>

                {/* Bottom */}
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <SoftBox
                    className="inspector-signature"
                    component="img"
                    src={inspectorSignature}
                    alt={`Signature Image`}
                    sx={{
                      width: "30%",
                      height: "80px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                  <SoftBox border="1px solid #212121" width="100%">
                    {" "}
                  </SoftBox>
                  <SoftTypography
                    fontSize="10px"
                    fontWeight="medium"
                    color="#212121"
                  >
                    {" "}
                    (Inspected By - Signature){" "}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>

          <SoftBox sx={{}}>
            {imagesDiscipline.length > 0 &&
              imagesDiscipline.map((item, index) => (
                <>
                  <SoftBox
                    key={index}
                    sx={{
                      width: "188mm", // A4 width
                      height: "260mm", // A4 height
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "start",
                      overflow: "hidden",
                      pageBreakBefore: "always",
                      pageBreakInside: "avoid",
                      breakInside: "avoid",
                      gap: 1,
                    }}
                  >
                    <SoftBox display="flex" gap={1}>
                      <SoftTypography
                        variant="h6"
                        fontSize="18px"
                        fontWeight="bold"
                        sx={{
                          whiteSpace: "nowrap",
                        }}
                        gap={1}
                      >
                        {discipline?.length > 1 && `${item?.label})`}{" "}
                        {discipline[0]?.disciplineName} :{" "}
                      </SoftTypography>

                      <SoftTypography
                        variant="h6"
                        fontSize="18px"
                        fontWeight="normal"
                      >
                        {" "}
                        {item?.inspectionType}{" "}
                      </SoftTypography>
                    </SoftBox>

                    <SoftBox
                      component="img"
                      className="pdf-image"
                      src={item?.image}
                      alt={`Discipline Image ${index}`}
                      // sx={{
                      //   height: "900px",
                      //   width: "800px",
                      //   aspectRatio: "4 / 3",
                      //   objectFit: "contain",
                      //   margin: "0 auto",
                      //   display: "block",
                      //      }}

                      sx={{
                        width: "100%",
                        maxWidth: "190mm",
                        height: "900px",
                        objectFit: "contain",
                      }}
                    />
                  </SoftBox>
                </>
              ))}
          </SoftBox>
        </Container>
      </SoftBox>

      {/* Pdf preview block */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        aria-labelledby="select-inspector-dialog"
        sx={{
          "& .MuiDialog-paper": {
            margin: 2,
            borderRadius: "12px",
            height: "90vh",
          },
        }}
      >
        <DialogTitle>PDF Preview</DialogTitle>
        <DialogContent
          sx={{
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          {pdfUrl && (
            <iframe
              src={pdfUrl ? `${pdfUrl}#toolbar=0` : ""}
              title="PDF Preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
        </DialogContent>

        {(inspectionData?.status === "ready_for_distribution" ||
          inspectionData?.status === "archived") && (
          <SoftBox
            fullWidth
            display="flex"
            alignItems="center"
            justifyContent="center"
            py={1}
          >
            <SoftButton
              href={pdfUrl}
              download={`${projectData?.name}   ${inspectionData?.inspection_number}.pdf`}
              variant="gradient"
              color="primary"
              sx={{
                padding: "0px",
                width: "200px",
                fontSize: "12px",
                borderRadius: "8px",
              }}
              onClick={() => setOpen(false)}
            >
              Download PDF
            </SoftButton>
          </SoftBox>
        )}
      </Dialog>
    </DashboardLayout>
  );
}

export default InspectionOverview;
